// removed by extract-text-webpack-plugin
module.exports = {"main_right_content":"components-tjcx-zsxxcx-index-main_right_content-DuGXo","table":"components-tjcx-zsxxcx-index-table-2c1kC"};


//////////////////
// WEBPACK FOOTER
// ./components/tjcx/zsxxcx/index.css
// module id = 2324
// module chunks = 0